import * as actions from './testsNames.actions'
import { identity } from 'fp-ts/lib/function'
import { Lens } from 'monocle-ts'
import { none, Option, some } from 'fp-ts/lib/Option'
import { Reducer } from 'src/framework'

export interface TestsNamesState {
  testsNames: Option<string[]>
}

export const testsNamesLense = Lens.fromProp<TestsNamesState>()('testsNames')

export const initialTestsNamesState: TestsNamesState = {
  testsNames: none
}

export const sameState: (s: TestsNamesState) => TestsNamesState = identity

export const testsNamesReducer: Reducer<actions.TestsNamesActions, TestsNamesState> = actions.testsNamesActions.match({
  LoadTestsNamesSuccess: action => testsNamesLense.set(some(action.testsNames)),
  LoadTestsNamesFailed: _action => testsNamesLense.set(none),
  default: _action => sameState
})



// WEBPACK FOOTER //
// ./src/tests-components/select-tests-names/testsNames.reducer.ts